import axios from 'axios';
import { useCallback, useEffect, useState } from 'react';
import { api } from '../../../../api';

export function useVideos(initialPageSize, authorId, bookId) {
  const [searchTerm, setSearchTerm] = useState('');

  const [currentPage, setCurrentPage] = useState(1);
  const [currentPageSize, setCurrentPageSize] = useState(initialPageSize);
  const [totalCount, setTotalCount] = useState(0);

  const [isLoading, setIsLoading] = useState(false);

  const [videos, setVideos] = useState([]);

  const refetchVideo = useCallback(
    (cancelToken) => {
      const params = {
        search: searchTerm || undefined,
        order: 'createdAt:desc',
      };

      if (currentPageSize) {
        params.limit = currentPageSize;
        params.offset = currentPageSize * (currentPage - 1);
      }

      if (authorId) {
        params.authorId = authorId;
      }
      if (bookId) {
        params.bookId = bookId;
      }

      setIsLoading(true);

      api.get('/v1/video', {
        params,
        cancelToken: cancelToken ? cancelToken.token : undefined,
      })
        .then((res) => {
          const { videos: videosData } = res.data;
          setTotalCount(res.data.totalCount);
          setVideos(videosData);
        })
        .finally(() => setIsLoading(false));
    },
    [authorId, bookId, currentPage, currentPageSize, searchTerm],
  );

  useEffect(() => {
    setCurrentPageSize(initialPageSize);
  }, [initialPageSize]);

  useEffect(() => {
    const cancelToken = axios.CancelToken.source();
    refetchVideo(cancelToken);
    return () => {
      cancelToken.cancel('VideoLibrary unmount');
    };
  }, [refetchVideo]);

  const handleSearchSubmit = (newSearchTerm) => {
    setCurrentPage(1);
    setSearchTerm(newSearchTerm);
  };

  return {
    videos,
    isLoading,
    refetchVideo,
    currentPage,
    setCurrentPage,
    totalCount,
    handleSearchSubmit,
    searchTerm,
    currentPageSize,
    setCurrentPageSize,
  };
}
